import { render } from "./pos-appearance.vue?vue&type=template&id=caa2724a"
import script from "./pos-appearance.vue?vue&type=script&lang=js"
export * from "./pos-appearance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__